import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export default {
  init() {
    // JavaScript to be fired on the home page
      console.log ($('.swiper'));
      const swiper = new Swiper ('.swiper-home', {
          loop: true,
          autoplay: {
              delay: 3000,
              disableOnInteraction: true
          },
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
          modules: [Autoplay, Navigation, Pagination],
      });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
